(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boosh-comparison"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initComparison(section) {
      if (!section || section.dataset.booshComparisonInitialized === 'true') {
        return;
      }

      var select = section.querySelector('[data-boosh-comparison-select]');
      if (!select) {
        return;
      }

      var competitorCells = section.querySelectorAll('[data-competitor]');

      function updateComparison() {
        var selected = select.value;

        competitorCells.forEach(function(cell) {
          var isMatch = cell.getAttribute('data-competitor') === selected;
          cell.hidden = !isMatch;
          cell.setAttribute('aria-hidden', String(!isMatch));
        });
      }

      select.addEventListener('change', updateComparison);
      updateComparison();
      section.dataset.booshComparisonInitialized = 'true';
    }

    function initWithin(root) {
      if (!root) {
        return;
      }

      if (root.matches && root.matches('[data-boosh-comparison-section]')) {
        initComparison(root);
      }

      root.querySelectorAll('[data-boosh-comparison-section]').forEach(initComparison);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initWithin(document);
      });
    } else {
      initWithin(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      initWithin(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
